import { render } from "./commands.vue?vue&type=template&id=4d80b21b&scoped=true"
import script from "./commands.vue?vue&type=script&lang=js"
export * from "./commands.vue?vue&type=script&lang=js"

import "./commands.vue?vue&type=style&index=0&id=4d80b21b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d80b21b"]])

export default __exports__